export default function Skeleton({
  rows = 3,
  header,
}: {
  rows?: number;
  header?: boolean;
}) {
  function getWidthByIndex(index: number) {
    const widths = ['w-1/2', 'w-5/6', 'w-3/4', 'w-2/3'];
    return widths[index % widths.length];
  }

  return (
    <div className="bg-white px-4 py-6 rounded-lg">
      <div className="space-y-5 bg-transparent">
        {header && (
          <div className="flex items-start justify-between mb-6">
            <div className="h-14 w-14 rounded-lg shimmer" />
            <div className="h-4 w-20 rounded shimmer" />
          </div>
        )}
        {Array.from({ length: rows }).map((_, j) => (
          <div
            // eslint-disable-next-line react-x/no-array-index-key
            key={j}
            className={`h-4 ${getWidthByIndex(j)} rounded shimmer`}
          />
        ))}
      </div>
    </div>
  );
}
